import script from "./Trigger.vue?vue&type=script&lang=ts"
export * from "./Trigger.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__